import React, { useState } from "react";
import { Grid, Typography, Box, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import styles from "./Services.module.css";

import Planning from "../../asset/planning.png";
import Encryption from "../../asset/encryption.png";
import Encryption1 from "../../asset/encryption1.png";
import Encryption2 from "../../asset/encryption2.png";
import Encryption3 from "../../asset/encryption3.png";
import Certificate from "../../asset/certificate.png";

const services = [
  { 
    title: "AI-Based Tools", 
    img: Planning,
    color: '#253044',
    description: "Advanced AI tools that automate complex tasks and provide intelligent insights. Our AI-based solutions leverage machine learning and natural language processing to enhance decision-making and operational efficiency across various business domains.",
    features: ["Machine Learning Algorithms", "Natural Language Processing", "Predictive Analytics", "Automated Decision Support"]
  },
  { 
    title: "Web Mebot Remediation", 
    img: Encryption,
    color: '#253044',
    description: "Comprehensive web bot remediation services that identify and fix vulnerabilities in your web applications. We ensure your digital assets are secure, compliant, and performing optimally.",
    features: ["Vulnerability Assessment", "Security Patching", "Performance Optimization", "Compliance Auditing"]
  },
  { 
    title: "App Mebot Monitoring", 
    img: Encryption1,
    color: '#253044',
    description: "24/7 monitoring of your application bots to ensure optimal performance, security, and reliability. Get real-time alerts and comprehensive analytics for your bot ecosystem.",
    features: ["Real-time Monitoring", "Performance Analytics", "Security Alerts", "Uptime Tracking"]
  },
  { 
    title: "Responsibility Consulting", 
    img: Encryption2,
    color:'#253044',
    description: "Expert consulting services to help organizations implement responsible AI practices, ensuring ethical compliance, transparency, and accountability in automated systems.",
    features: ["AI Ethics Framework", "Compliance Strategy", "Risk Assessment", "Stakeholder Training"]
  },
  { 
    title: "Multimedia Mebot", 
    img: Encryption3,
    color: '#253044',
    description: "Intelligent multimedia bots that process, analyze, and generate content across various media formats including images, video, and audio with AI-powered capabilities.",
    features: ["Image Recognition", "Video Analysis", "Audio Processing", "Content Generation"]
  },
  { 
    title: "Mebot Cost Estimation", 
    img: Certificate,
    color: '#253044',
    description: "Accurate cost estimation and ROI analysis for implementing and maintaining bot solutions. We help you plan budgets and measure returns effectively.",
    features: ["Cost Analysis", "ROI Calculation", "Budget Planning", "Implementation Strategy"]
  },
];

const Services = () => {
  const isDesktop = window.innerWidth > 1024;

  const [selectedService, setSelectedService] = useState(services[0]);
  const [isDetailOpen] = useState(isDesktop);

  const handleServiceClick = (service) => {
    setSelectedService(service);
  };

  const handleCloseDetail = () => {
    return;
  };

  return (
    <section className={styles.section}>
      <Box className={`${styles.container} ${isDetailOpen ? styles.containerExpanded : ''}`}>
        <Typography className={styles.title}>
          Services We Offer:
        </Typography>

        <div className={styles.servicesWrapper}>
  {/* First Row */}
  <Grid container className={styles.gridRow} spacing={isDesktop ? 4 : 2}>
    {services.slice(0, 3).map((service, index) => (
      <Grid item xs={6} md={2} key={index} className={styles.serviceGridItem}>
        <div
          className={`${styles.serviceItem} ${selectedService?.title === service.title ? styles.activeService : ''}`}
          onClick={() => handleServiceClick(service)}
          style={{ '--service-color': service.color }}
        >
          <div className={styles.circle}>
            <img src={service.img} alt={service.title} className={styles.serviceIcon} />
          </div>
          <Typography className={styles.serviceTitle}>
            {service.title}
          </Typography>
        </div>
      </Grid>
    ))}
  </Grid>

  {/* Second Row */}
  <Grid container className={styles.gridRow} spacing={isDesktop ? 4 : 2}>
    {services.slice(3, 6).map((service, index) => (
      <Grid item xs={6} md={2} key={index + 3} className={styles.serviceGridItem}>
        <div
          className={`${styles.serviceItem} ${selectedService?.title === service.title ? styles.activeService : ''}`}
          onClick={() => handleServiceClick(service)}
          style={{ '--service-color': service.color }}
        >
          <div className={styles.circle}>
            <img src={service.img} alt={service.title} className={styles.serviceIcon} />
          </div>
          <Typography className={styles.serviceTitle}>
            {service.title}
          </Typography>
        </div>
      </Grid>
    ))}
  </Grid>
</div>

        <div className={styles.detailPanelContainer}>
          <div className={styles.detailPanel}>
            {selectedService && (
              <Box
                className={styles.detailContent}
                style={{ '--service-color': selectedService.color }}
              >
                {/* <IconButton className={styles.closeButton}>
                  <CloseIcon />
                </IconButton> */}

                <div className={styles.detailHeader}>
                  <div className={styles.detailCircle}>
                    <img src={selectedService.img} alt={selectedService.title} className={styles.detailIcon} />
                  </div>
                  <Typography variant="h3" className={styles.detailTitle}>
                    {selectedService.title}
                  </Typography>
                </div>

                <Typography className={styles.detailDescription}>
                  {selectedService.description}
                </Typography>

                <div className={styles.featuresSection}>
                  <Typography className={styles.featuresTitle}>
                     Features
                  </Typography>
                  <ul className={styles.featuresList}>
                    {selectedService.features.map((feature, index) => (
                      <li key={index} className={styles.featureItem}>
                        {feature}
                      </li>
                    ))}
                  </ul>
                </div>
              </Box>
            )}
          </div>
        </div>
      </Box>
    </section>
  );
};

export default Services;